import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { getBaseURL } from "../../../../env/stage";
import CopyTextButton from "../../../../common/components/CopyTextButton";
import { Label } from "@atlaskit/form";

const CustomWebhookWidget = () => {
  const flow = useSelector((state) => state.integration.flow);

  const getToken = useMemo(() => {
    return flow?.trigger?.value ? flow.trigger.value : "{save-to-get-token}";
  }, [flow]);

  const webhookURL = `${getBaseURL()}/incoming/webhook?token=${getToken}`;

  return (
    <div className="ihub-edit-trigger">
      <p>
        Incoming webhooks serve as endpoints for external systems to initiate (run) this flow. When a system sends a POST request to the specified URL
        with the appropriate data payload, the flow is activated. (You need to <b>save</b> and <b>enable</b> this flow to generate the full URL)
      </p>
      <Label>Method:</Label> <span className="ihub-action-menu-list-method POST">POST</span>
      <br />
      <Label>URL:</Label>
      <code > {webhookURL}</code>
      <CopyTextButton copyText={webhookURL} />
    </div>
  );
};

export default CustomWebhookWidget;
